import styled from "styled-components";

const Section = styled.section`
    margin: 50px 0;

    & h1 {
        margin: 25px 0;
    }
`;

export default Section;
